import React from 'react';
import { Building2 } from 'lucide-react';

type Props = {
  tableName: string;
  hotelName: string;
};

export const RoomHeader = ({ tableName, hotelName }: Props) => {
  return (
    <div>
      <div className="flex items-center gap-3 mb-2">
        <div className="p-2 bg-primary-50 rounded-lg">
          <Building2 className="text-primary-500" size={24} />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-gray-900">{tableName}</h1>
          <p className="text-gray-500">{hotelName}</p>
        </div>
      </div>
    </div>
  );
};